import { useQuery } from 'react-query'
import { fetchYearlyTests, YearlyTestsRequestParams } from 'api/tests'

export const useFetchYearlyTests = (params: YearlyTestsRequestParams) => {
  return useQuery(['fetchYearlyTest', params], fetchYearlyTests(params))
}
